import { ActionWithPayload } from "@obg/ngrx-utils";

import { USER_GAMES_ACTION_TYPE } from "./user-games.action";
import { UserGamesState } from "./user-games.model";

const INITIAL_STATE: UserGamesState = {
	lastPlayed: [],
};

export function userGamesReducer(state = INITIAL_STATE, action: ActionWithPayload): UserGamesState {
	switch (action.type) {
		case USER_GAMES_ACTION_TYPE.getAllLastPlayedSuccess:
			return {
				...state,
				lastPlayed: action.payload,
			};
		case USER_GAMES_ACTION_TYPE.reset:
			return INITIAL_STATE;
		case USER_GAMES_ACTION_TYPE.updateLastPlayedGame:
			return {
				...state,
				lastPlayed: [action.payload, ...state.lastPlayed.filter((id) => id !== action.payload)],
			};
		default:
			return state;
	}
}
